import { gql } from "@apollo/client";

export const GET_EVENTS_COUNT = gql`
  query getEventsCount($eventsCountArgs: EventsCountArgsInput!) {
    getEventsCount(eventsCountArgs: $eventsCountArgs) {
      count
    }
  }
`;
